// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__Kvsjr","text":"Alert_text__dxNQ7","arrow":"Alert_arrow__cP5dH"};